import classNames from 'classnames';
import React from 'react';
import UDFormFieldWrapper from '../../wrapper';
import { UDFormComponentProps } from '../types';
import UDCheckbox, { UDCheckboxProps } from './component';

type Props = UDCheckboxProps & UDFormComponentProps;

const UDFormCheckbox = (props: Props) => {
  const {
    name,
    required,
    labelProps,
    label,
    containerProps,
    ...checkboxProps
  } = props;
  return (
    <UDFormFieldWrapper
      name={name}
      required={required}
      label={label}
      labelProps={{
        ...labelProps,
        style: { marginBottom: 0, ...labelProps?.style },
      }}
      containerProps={{
        ...containerProps,
        className: classNames(
          'd-flex flex-row-reverse',
          containerProps?.className,
        ),
      }}>
      {({ field }) => (
        <UDCheckbox {...checkboxProps} {...field} checked={field.value} />
      )}
    </UDFormFieldWrapper>
  );
};

export default UDFormCheckbox;
